import { useBreakoutUser } from 'hooks/profile'
import { useRootStore } from 'hooks/rootStore'
import { observer } from 'mobx-react-lite'
import type { ReactNode } from 'react'
import { useEffect } from 'react'

// capability-based guard: access is granted by the externalCanDemo
// profile flag, not by role (see BL-4556); admin/corre may also enter
// so they can preview the external users' UI
export const ExternalDemoGuard = observer(function ExternalDemoGuard({
  children,
}: {
  children: ReactNode
}) {
  const { navigateTo } = useRootStore()
  const user = useBreakoutUser()
  const externalCanDemo = user.externalCanDemo
  const allowed =
    user.isCorre || (externalCanDemo.isLoaded && externalCanDemo.value)

  useEffect(() => {
    if (externalCanDemo.isLoaded && !allowed) {
      // The user is not authorized to view this page, redirect them to the home page.
      navigateTo('home')
    }
  }, [navigateTo, externalCanDemo.isLoaded, allowed])

  if (!allowed) {
    // Show nothing while loading or waiting for the redirect home.
    return null
  }

  return children
})
